import { createContext } from "react";

import type { OptionPageSupport } from "./optionPageSupport";

/**
 * Support of the current route, provided by `OptionPageGuard` while a design
 * option is selected. `undefined` outside the guard.
 */
export const OptionPageSupportContext = createContext<
  OptionPageSupport | undefined
>(undefined);
